import { useMutation, useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import EntityService from "services/Entity";

// ["entity"] covers the Entities table and the ["entity", id, …] queries that
// the Contact, Case, and Campaign target pages read.
const invalidateEntities = () =>
  queryClient.invalidateQueries({ queryKey: ["entity"] });

export const useEntity = id =>
  useQuery({
    queryKey: ["entity", id],
    queryFn: () => EntityService.getEntity(id),
    enabled: !!id,
    retry: false,
  });

export const useEntityMutations = () => {
  const create = useMutation({
    mutationFn: data => EntityService.createEntity(data),
    onSuccess: invalidateEntities,
  });

  const update = useMutation({
    mutationFn: ({ id, data }) => EntityService.editEntity(id, data),
    onSuccess: invalidateEntities,
  });

  return { create, update };
};
